import React, { createContext, useContext, useState } from "react";
import { useEffect } from "react";
import themes from "devextreme/ui/themes";

// Context to manage the current theme (images, etc.)
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentModule, setCurrentModule] = useState("osiris"); // default module

  const value = {
    currentModule,
    setCurrentModule,
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

// Hook to use the theme context
export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
};

// Switching CSS stylesheet to the selected module (Bootstrap styles)
export default function useTheme(module) {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `/assets/css/falcon-${module}.css`;
    link.id = "theme-style";
    document.head.appendChild(link);

    return () => {
      const existing = document.getElementById("theme-style");
      if (existing) existing.remove();
    };
  }, [module]);
}

// Switching DevExtreme theme CSS based on module + light mode
export function useDevExtremeTheme(module, lightMode) {
  useEffect(() => {
    themes.current(`${module}.${lightMode}`);
  }, [module, lightMode]);
}
